import React, { FunctionComponent } from 'react';

import { cn } from 'Modules/ui';

import styles from './index.module.scss';

/*
    BLOCK: image
    PARAMS: file: object,
            caption: string,
            withBorder: boolean,
            withBackground: boolean,
            stretched: boolean
    EXAMPLE:
    {
        "type" : "image",
        "data" : {
            "file": {
                "url" : "https://www.tesla.com/tesla_theme/assets/img/_vehicle_redesign/roadster_and_semi/roadster/hero.jpg"
            },
            "caption" : "Roadster // tesla.com",
                "withBorder" : false,
                "withBackground" : false,
                "stretched" : true
        }
    }
 */

interface ImageFile {
    url: string;
}

interface ImageRendererProps {
    file: ImageFile;
    caption?: string;
    withBorder?: boolean;
    withBackground?: boolean;
    stretch?: boolean;
}

export const ImageRenderer: FunctionComponent<ImageRendererProps> = ({
    file,
    caption,
    withBorder,
    withBackground,
    stretch,
}) => (
    <img
        className={cn(
            styles.image,
            withBorder && 'image__withBorder',
            withBackground && 'image__withBackground',
            stretch && 'image__stretch',
        )}
        src={file.url}
        alt={caption}
    />
);

ImageRenderer.defaultProps = {
    caption: '',
    withBorder: false,
    withBackground: false,
    stretch: false,
} as Partial<ImageRendererProps>;
